import {
  ActionIcon,
  Box,
  Button,
  Group,
  Paper,
  ScrollArea,
  useMantineTheme,
  Text,
  Image,
  Dialog,
  Badge,
} from "@mantine/core";
import { Pencil, Plus, Trash } from "tabler-icons-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Th from "features/backstage/_shared/Th";

import { useCategoriesQuery, useDeleteCategoryMutation } from "services/api";
import Table from "features/backstage/_shared/Table";
import { showNotification } from "@mantine/notifications";

const List = () => {
  const theme = useMantineTheme();
  const { data: categories = [] } = useCategoriesQuery();

  const [deleteCategory] = useDeleteCategoryMutation();
  const [deleteCategoryId, setDeleteCategoryId] = useState<number>();

  const [sort, setSort] = useState<string>();
  const [isDescending, setIsDescending] = useState(false);

  const handleSort = (sortBy: string) => () => {
    if (sortBy === sort) {
      setIsDescending((prev) => !prev);
      return;
    }

    setSort(sortBy);
    setIsDescending(false);
  };

  const sortedCategory =
    sort !== undefined
      ? categories
          .slice(0)
          .sort((x, y) => (y.sort - x.sort) * (isDescending ? 1 : -1))
      : categories;

  const rows = sortedCategory.map((row) => (
    <tr key={row.id}>
      <td>{row.name}</td>
      <td>{row.url}</td>
      <td>
        <Image width={40} src={row.icon}></Image>
      </td>
      <td>
        {row.display ? (
          <Badge
            color="cyan"
            variant={theme.colorScheme === "dark" ? "light" : "outline"}
          >
            {row.display === 2 ? "公開" : "限市府人員"}
          </Badge>
        ) : (
          <Badge
            color="gray"
            variant={theme.colorScheme === "dark" ? "light" : "outline"}
          >
            隱藏下架
          </Badge>
        )}
      </td>
      <td>{row.sort}</td>
      <td>
        <Group spacing={0} position="right">
          <ActionIcon color="gray" component={Link} to={`${row.id}/edit`}>
            <Pencil size={20} />
          </ActionIcon>
          <ActionIcon color="red" onClick={() => setDeleteCategoryId(row.id)}>
            <Trash size={20} />
          </ActionIcon>
        </Group>
      </td>
    </tr>
  ));

  return (
    <Box py={8} px={36}>
      <Group position="apart">
        <h2>儀表板分類管理</h2>
        <Button
          component={Link}
          to="new"
          leftIcon={<Plus />}
          variant="outline"
          color="cyan"
        >
          新增儀表板分類
        </Button>
      </Group>

      <Paper
        px={16}
        pt={8}
        pb={8}
        mt={16}
        radius={"lg"}
        shadow={theme.shadows.lg}
      >
        <ScrollArea>
          <Table>
            <thead>
              <tr>
                <th>分類名稱</th>
                <th>分類網址</th>
                <th>圖示</th>
                <th>資料顯示</th>
                <Th
                  sorted={sort === "sort"}
                  reversed={isDescending}
                  onSort={handleSort("sort")}
                >
                  順序
                </Th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows
              ) : (
                <tr>
                  <td colSpan={6}>
                    <Text weight={500} align="center">
                      沒有找到相關資料
                    </Text>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ScrollArea>
      </Paper>

      <Dialog
        opened={deleteCategoryId !== undefined}
        withCloseButton
        onClose={() => setDeleteCategoryId(undefined)}
        size="lg"
        radius="md"
      >
        <Group align="center">
          <Text size="sm" weight={500}>
            確定刪除分類？
          </Text>
          <Button
            color="red"
            onClick={async () => {
              try {
                await deleteCategory(deleteCategoryId).unwrap();
              } catch (e) {
                if (e.status === 409) {
                  showNotification({
                    title: "刪除失敗",
                    message: "僅能刪除不包含任何圖表的分類",
                    color: "red",
                  });
                }
              } finally {
                setDeleteCategoryId(undefined);
              }
            }}
          >
            確認刪除
          </Button>
        </Group>
      </Dialog>
    </Box>
  );
};
export default List;
